import React from "react";

import "./Title.scss";

import laptopDogImg from "../../assets/img/person-laptop-dog.png";
import thoughtBubbleImg from "../../assets/img/thought-bubble.svg";
import germ1Img from "../../assets/img/germ-6-orange.svg";
import germ2Img from "../../assets/img/germ-2.svg";
import germ3Img from "../../assets/img/germ-1-yellow.svg";
import germ4Img from "../../assets/img/germ-3-turquoise.svg";
import germ5Img from "../../assets/img/germ-3-orange.svg";

export default function Title() {
  return (
    <section className="title">
      <div className="title__container">
        <div className="title__heading">
          WHAT IS A <br /> <span>VIRUS?</span>
        </div>
        <div className="title__computer-dog">
          <img src={laptopDogImg} alt="" className="img-fluid" />
        </div>
        <div className="title__text">
          Viruses are one of the many germs that make us sick.
        </div>
        <div className="title__virus-container">
          <div className="title__virus title__virus--1 rotate delay-random-1">
            <img src={germ1Img} alt="" className="img-fluid" />
          </div>
          <div className="title__virus title__virus--2 rotate delay-random-2">
            <img src={germ2Img} alt="" className="img-fluid" />
          </div>
          <div className="title__virus title__virus--3  rotate delay-random-3">
            <img src={germ3Img} alt="" className="img-fluid" />
          </div>
          <div className="title__virus title__virus--4  rotate delay-random-4">
            <img src={germ4Img} alt="" className="img-fluid" />
          </div>
          <div className="title__virus title__virus--5  rotate delay-random-5">
            <img src={germ5Img} alt="" className="img-fluid" />
          </div>
        </div>
        <div className="title__thought-bubble">
          <img src={thoughtBubbleImg} alt="" className="img-fluid" />
        </div>
      </div>
    </section>
  );
}
